module.exports = __webpack_public_path__ + "static/media/galleryImg22.949b4ae3.jpg";